import React from 'react'
import { Box, Stepper, Step, StepLabel, StepContent, Typography } from '@mui/material'
import { product } from '../../constants/product'

export const TermsCondition = () => {
  const steps = [
    {
      label: 'Step 3',
      description: `Fill in the form and attach a digital copy of your proof of purchase and photo of car plate number.`
    },
    {
      label: 'Step 4',
      description: `Submit the completed form. By submitting this form, you confirm that you have read, understood, and will respect the terms and conditions & PDPA.`
    },
    {
      label: 'Step 5',
      description: `You will receive Touch'N Go reload pin number within 3 working days if your submission is approved.`
    }
  ]

  return (
    <Box
      minHeight={350}
      maxWidth={900}
      px={3}
      py={5}
      display='flex'
      justifyContent='center'
      alignContent='center'
      m='auto'
      flexDirection='column'
    >
      <Stepper orientation='vertical'>
        <Step active={true}>
          <StepLabel>Step 1</StepLabel>
          <StepContent>
            <Typography variant='h3'>
              Purchase any of the following eligible products from participating dealers since 31st
              March 2026 to 4th April 2026.
            </Typography>
            <br />
            {product.map((item, index) => (
              <Typography fontWeight='bold' key={index}>
                {item}
              </Typography>
            ))}
          </StepContent>
        </Step>
        <Step active={true}>
          <StepLabel>Step 2</StepLabel>
          <StepContent>
            <Typography variant='h3'>
              Scan the QR code or visit <a href='/register'>https://htofm.com.my/register</a> to
              access the entry page.
            </Typography>
          </StepContent>
        </Step>
        {steps.map((step, index) => (
          <Step key={step.label} active={true}>
            <StepLabel
              optional={index === 2 ? <Typography variant='caption'>Last step</Typography> : null}
            >
              {step.label}
            </StepLabel>
            <StepContent>
              <Typography variant='h3'>{step.description}</Typography>
            </StepContent>
          </Step>
        ))}
      </Stepper>
      <Box mt={3}>
        <Typography variant='h4'>
          I have read and agree with the{' '}
          <a
            style={{ color: '#002984' }}
            href={'client-static/documents/Terms and Conditions.pdf'}
            target='_blank'
            rel='noopener noreferrer'
          >
            Terms & Conditions
          </a>{' '}
          and{' '}
          <a
            style={{ color: '#002984' }}
            href={'client-static/documents/Personal Data and Privacy Notice.pdf'}
            target='_blank'
            rel='noopener noreferrer'
          >
            Privacy Policy.
          </a>
        </Typography>
      </Box>
    </Box>
  )
}
